import React from "react"
import { values } from "lodash"
import CoolPage from "../components/CoolPage"
import {products} from "../../../../data"

import "./MenuContent.less"

class MenuContent extends React.PureComponent {
  render() {
    const product = products[this.props.match.params.product_id] || products[encodeURIComponent(this.props.match.params.product_id)]
    const menu = product.menus[this.props.match.params.menu_id] || product.menus[encodeURIComponent(this.props.match.params.menu_id)]

    return (
      <CoolPage
        containerProps={{  }}
        title={"套餐内容"}
        barColor={[255, 255, 255]}
        fixedBar
        className="menuContent"
        
      >
        <div className="title">{menu.chName}</div>
        <div className="dishesContainer">  
          {values(menu.dishes).map(dish => (
            <div key={dish.id} className="dish">
              <div
                className="dishimage"
                style={{
                  backgroundImage: `url(${dish.background.image})`,
                }}
              />
              <div className="texts">
                <div className="dishtitle">{dish.chName}</div>
                <div className="dishdescription">{dish.description}</div>
              </div>
            </div>
          ))}
          
        </div>
      </CoolPage>
    )
  }
}

export default MenuContent



// WEBPACK FOOTER //
// ./src/app/catalogo/products/MenuContent.jsx